




























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class AddBoxDialog extends Vue {
  @Prop(Boolean) readonly active: boolean | undefined;

  @Prop(Array) readonly boxes: any[] | undefined;

  // eslint-disable-next-line class-methods-use-this
  data() {
    return {
      currentValue: null,
    };
  }

  onStateChanged(state: boolean) {
    if (state === false) {
      this.$emit('close');
    }
  }

  onBoxAddSubmitted() {
    this.$emit('input', this.$data.currentValue);
    this.$emit('close');
  }
}
